import * as types from '../mutation-types'
import vueCookie from 'vue-cookie'

// initial state
const state = {
    cookieLeague : (vueCookie.get(window.compcode + '_league') != 'undefined') ? JSON.parse(vueCookie.get(window.compcode + '_league')) : null,
    selectAllLeague : (vueCookie.get(window.compcode + '_league') != 'undefined') ? false : true,
    cookieHistory   : (vueCookie.get(window.compcode + '_his') != 'undefined') ? JSON.parse(vueCookie.get(window.compcode + '_his')) : null,
    searchHistory   : [],
    searchLoading   : false,
    historyList     : [],
    searchLeague    :  {
        lid: 0,
        lname: '',
    },
}

// getters
const getters = {
  cookieLeague: state => state.cookieLeague,    
  selectAllLeague : state => state.selectAllLeague,
  cookieHistory   : state => state.cookieHistory,
  searchHistory   : state => state.searchHistory,
  searchLoading   : state => state.searchLoading,
  historyList     : state => state.historyList,
  searchLeague    : state => state.searchLeague,
}

// actions
const actions = {
    
}

// mutations
const mutations = {
    [types.SEARCH_LEAGUE] (state,payload) {
        state.searchLeague = payload
    },
    [types.SELECT_ALL_LEAGUE] (state,payload) {
        state.selectAllLeague = payload
    },
    [types.COOKIE_LEAGUE] (state, payload ) {
        var selectedMarket = this.getters.selectedMarket
        var selectedSport = this.getters.selectedBettype.sprtId
        var selectedBettype = this.getters.selectedBettype.betTypId
        if(this.getters.isGameBannerSelected) {
            selectedBettype += 'gmBanner'
        }
        if(payload.remove){
            if(this.getters.cookieLeague){
                if(this.getters.cookieLeague[selectedMarket]){
                    if(this.getters.cookieLeague[selectedMarket][selectedSport]){
                        if(this.getters.cookieLeague[selectedMarket][selectedSport][selectedBettype]){
                            state.cookieLeague[selectedMarket][selectedSport][selectedBettype] = []
                            vueCookie.set(window.compcode + '_league', JSON.stringify(state.cookieLeague))
                        }
                    }
                }
            }
            // vueCookie.delete(window.compcode + '_league')
            return
        }
        
        let VUE = this
        function recursiveMethod(value, type, league){
            var selectedMarket = VUE.getters.selectedMarket
            var selectedSport = VUE.getters.selectedBettype.sprtId
            var selectedBettype = VUE.getters.selectedBettype.betTypId
            if(VUE.getters.isGameBannerSelected) {
                selectedBettype += 'gmBanner'
            }
            if(value == null && type =='market') {
                value[selectedMarket] = {}
                return recursiveMethod(value[selectedMarket], 'sport', league)
            }

            if(value == null && type =='sport') {
                value[selectedMarket][selectedSport] = {}
                return  recursiveMethod(value[selectedMarket][selectedSport], 'bettyp', league)
            }
            
            if(value == null && type =='bettyp') {
                value[selectedMarket][selectedSport][selectedBettype] = []
                value[selectedMarket][selectedSport][selectedBettype] = league
                return value;
            }else {
                if(value == null){
                    return recursiveMethod(value, 'market', league)
                }
                if(value[selectedMarket] == null){
                    value[selectedMarket] = {}
                    return recursiveMethod(value, 'sport', league)
                }
                if(value[selectedMarket][selectedSport] == null){
                    value[selectedMarket][selectedSport] = {}
                    return  recursiveMethod(value, 'bettyp', league)
                }
                if(value[selectedMarket][selectedSport][selectedBettype] == null){
                    value[selectedMarket][selectedSport][selectedBettype] = league
                    return value;
                }
                value[selectedMarket][selectedSport][selectedBettype] = league
                return value;
            }
        }
        if(this.getters.cookieLeague){
            //if cookie is set already            
            var cookie = ''
            cookie = recursiveMethod(this.getters.cookieLeague, 'market', payload.selectedLeague)
            state.cookieLeague = cookie
            vueCookie.set(window.compcode + '_league', JSON.stringify(cookie))
        }else{
            //league cookie initiation
            //if cookie is not set
            var selectedCookieLeague = {};
            selectedCookieLeague[selectedMarket] = {}
            selectedCookieLeague[selectedMarket][selectedSport] = {}
            selectedCookieLeague[selectedMarket][selectedSport][selectedBettype] = payload.selectedLeague
            state.cookieLeague = selectedCookieLeague
            vueCookie.set(window.compcode + '_league', JSON.stringify(selectedCookieLeague))
            return
        }
        //vueCookie.set(window.compcode + '_league', JSON.stringify(payload.selectedLeague))
    },   
    [types.COOKIE_HISTORY] (state, payload){
        //history arr = account code->history
        let currentAcc = this.getters.account.acccode

        if(payload.remove){
            if(this.getters.cookieHistory){
                state.cookieHistory = []
                vueCookie.set(window.compcode + '_his', JSON.stringify(state.cookieHistory))
            }
            return
        }

        if(payload.removeSelected){
            if(this.getters.cookieHistory){
                state.cookieHistory = _.pull(this.getters.cookieHistory, payload.searchVal)
                vueCookie.set(window.compcode + '_his', JSON.stringify(state.cookieHistory))
            }
            return
        }
        if(_.includes(state.cookieHistory, payload.searchVal)){
            return
        }
        let VUE = this
        if(state.cookieHistory && state.cookieHistory && state.cookieHistory.length>0){
            state.searchHistory = _.reverse(state.cookieHistory)
        }
        if(state.searchHistory.length==0 || state.searchHistory.length <3){
            if(payload.searchVal!=''){
                state.searchHistory.push(payload.searchVal)
            }
        }else{
            if(payload.searchVal!=''){
                // state.searchHistory = _.reverse(state.searchHistory)
                state.searchHistory.shift()
                state.searchHistory.push(payload.searchVal)
            }
        }
        var selectedCookieLeague = {};
        selectedCookieLeague = _.reverse(state.searchHistory)
        state.cookieHistory = selectedCookieLeague
        vueCookie.set(window.compcode + '_his', JSON.stringify(selectedCookieLeague))

        return
    },
    [types.SEARCH_LOADING] (state, payload){
        state.searchLoading = payload
    },
    [types.HIST_LIST] (state, payload) {
        state.historyList = payload
    } 
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/sport-league.js